module.exports = __webpack_public_path__ + "img/logo-caps.46a79970.png";